import React, { ReactElement } from 'react'
import { MenuOption } from './index'
import Checkbox from '../../Checkbox'
import Loader from '../../Loader'
import MenuItemIcon from '../../MenuItemIcon/MenuItemIcon'

type Props = {
    menuOption: MenuOption
}

/**
 * Standard menu entry for the row menu.
 *
 * @param menuOption - The data for the row entry.
 */
const StandardMenuEntry: React.FC<Props> = ({ menuOption }: Props): ReactElement => {
    const isCheckboxShow: boolean = menuOption?.checked !== undefined

    const iconOption = (): ReactElement => {
        if (isCheckboxShow) {
            return <Checkbox isChecked={!!menuOption.checked} />
        }
        if (menuOption?.renderedIcon) {
            return menuOption.renderedIcon
        }

        return <MenuItemIcon iconName={menuOption?.icon} />
    }

    return menuOption.isVisible ? (
        <li
            className={`om-entry ${isCheckboxShow ? 'has-checkbox' : ''} ${menuOption.loading ? 'has-loader' : ''}`}
            title={menuOption?.tooltip}
        >
            <a
                className={`ome-anchor ${menuOption?.isEnabled ? '' : 'disabled'} ${
                    menuOption?.checked ? 'checked' : ''
                }`}
                onMouseDown={(e: React.MouseEvent<Element, MouseEvent>): void => {
                    if (menuOption?.isEnabled && menuOption?.onClick) {
                        menuOption.onClick(e)
                    }
                }}
                onMouseOver={menuOption?.onHover}
            >
                {menuOption.loading ? (
                    <span className='ome-loader'>
                        <Loader size={16} />
                    </span>
                ) : (
                    iconOption()
                )}
                <span className='omea-title'>{menuOption.title}</span>
            </a>
        </li>
    ) : (
        <></>
    )
}

export default StandardMenuEntry
